import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {
  Button,
  Modal,
  Paragraph,
  RoboyuConfused,
  RoboyuOffer,
} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {TemplateSorryModalContentProps} from './TemplateSorryModalContentProps'

const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
`

const StyledParagraph = styled(Paragraph)`
  margin: ${convertUnit(15)} 0;
  padding: 0;
  text-align: center;
`

const StyledTitle = styled(Paragraph)`
  text-align: center;
`

const StyledImageContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default function TemplateSorryModalContent({
  visible,
  upperDesc,
  bottomDesc,
  robopetImage = true,
  toggleModal,
}: TemplateSorryModalContentProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible={visible} onBackdropPress={toggleModal}>
      <StyledTitle fontSize="xl" fontWeight="bold">
        {translate('global:sorry')}
      </StyledTitle>
      <StyledParagraph fontSize="m">{upperDesc}</StyledParagraph>
      <StyledImageContainer>
        {robopetImage ? (
          <RoboyuOffer
            width={convertUnit(200)}
            height={convertUnit(200)}
            colorTheme={colorTheme.name}
          />
        ) : (
          <RoboyuConfused
            width={convertUnit(200)}
            height={convertUnit(200)}
            colorTheme={colorTheme.name}
          />
        )}
      </StyledImageContainer>
      <StyledParagraph fontSize="m" color="gray_6">
        {bottomDesc}
      </StyledParagraph>
      <Button label={translate('global:ok')} onClick={toggleModal} />
    </StyledModal>
  )
}
